import { render, staticRenderFns } from "./MultiSelectItem.vue?vue&type=template&id=defa2d88&scoped=true&"
import script from "./MultiSelectItem.vue?vue&type=script&lang=ts&"
export * from "./MultiSelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelectItem.vue?vue&type=style&index=0&id=defa2d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defa2d88",
  null
  
)

export default component.exports